export default "__VITE_ASSET__4ed032f7__"